export const fetchIpLocationApi = async (ip: string) => {
  const response = await fetch(`https://ipwho.is/${ip}`);
  const data = await response.json();

  if (!data.success) {
    throw new Error("IP location fetch failed");
  }

  return data;
};
